import styled from 'styled-components';

export const Container = styled.div`
  padding: 0px;
  max-width: 100%;
  overflow-x: hidden;
`;

export const FormContainer = styled.div`
  padding: 24px;

  @media (max-width: 768px) {
    padding: 20px;
  }

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const StepForm = styled.div`
  @media (max-width: 768px) {
    overflow-x: hidden;
  }
`;

export const Header = styled.div`
  padding: 24px 18px 0 18px;

  h3 {
    color: #393939;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    @media (max-width: 768px) {
      font-size: 16px;
    }

    @media (max-width: 480px) {
      font-size: 15px;
    }
  }

  @media (max-width: 768px) {
    padding: 20px 16px 0 16px;
  }

  @media (max-width: 480px) {
    padding: 16px 12px 0 12px;
  }
`;

export const FormTitle = styled.h4`
  font-size: 14px;
  font-weight: 800;
  line-height: 19px;
  margin: 10px 0 !important;
  color: #393939;

  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 18px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const Line = styled.div`
  height: 1px;
  background: #364445;
`;

export const Form = styled.div`
  padding-bottom: 20px;

  label {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0em;

    @media (max-width: 768px) {
      font-size: 13px;
      gap: 8px;
    }

    @media (max-width: 480px) {
      font-size: 12px;
    }
  }

  input {
    width: 100%;
    min-height: 44px;
    font-size: 16px !important; /* Previne zoom no iOS */

    @media (max-width: 768px) {
      min-height: 42px;
    }
  }

  .row input {
    margin-top: 0px;
  }

  .ui.grid > .row {
    padding-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding-bottom: 16px;
  }

  @media (max-width: 480px) {
    padding-bottom: 12px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  align-items: center;
  width: 100%;
  margin-top: 15px;

  button {
    min-height: 44px;
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 10px;

    button {
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

export const Steper = styled.div`
  display: flex;
  padding: 10px 0px;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 4px;
  margin-bottom: 20px;
  margin: 10px 25px 0 25px;
  position: relative;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 768px) {
    margin: 10px 16px 0 16px;
    padding: 8px 0px;
    flex-wrap: nowrap;
  }

  @media (max-width: 480px) {
    margin: 8px 12px 0 12px;
  }
`;

export const StepItem = styled.div<{ active: boolean; theme: any }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 10px);
  min-width: 120px;
  height: 40px;
  background: ${({ active, theme }) => (active ? theme.main.color : '#FFFFFF')};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0em;
  color: ${({ active, theme }) => (active ? '#FFFFFF' : theme.main.color)};
  font-weight: 600;
  cursor: pointer;
  position: relative;
  border: 1px solid #ccc;
  border-right: none;
  border-left: none;
  white-space: nowrap;
  padding: 0 8px;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: -10px;
    width: 0;
    height: 0;
    border-top: 19px solid transparent;
    border-bottom: 19px solid transparent;
    border-left: 10px solid ${({ active, theme }) => (active ? theme.main.color : '#fff')};
    z-index: 2;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: -11px;
    width: 0;
    height: 0;
    border-top: 19px solid transparent;
    border-bottom: 19px solid transparent;
    border-left: 11px solid #ccc;
    z-index: 1;
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-left: 1px solid #ccc;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-right: 1px solid #ccc;
  }

  &:last-child::after {
    display: none;
  }

  &:last-child::before {
    display: none;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    height: 36px;
    min-width: 100px;

    &::after {
      border-top: 17px solid transparent;
      border-bottom: 17px solid transparent;
    }

    &::before {
      border-top: 17px solid transparent;
      border-bottom: 17px solid transparent;
    }
  }

  @media (max-width: 480px) {
    font-size: 12px;
    height: 34px;
    min-width: 90px;

    &::after {
      border-top: 16px solid transparent;
      border-bottom: 16px solid transparent;
    }

    &::before {
      border-top: 16px solid transparent;
      border-bottom: 16px solid transparent;
    }
  }
`;

export const TextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > textarea {
    width: 100%;
    border-radius: 4px;
    border: 1px solid rgba(34, 36, 38, 0.15);
    padding: 10px 5px;
    outline: 0;
    resize: none;
    min-height: 100px;
    font-size: 16px !important; /* Previne zoom no iOS */

    &:focus {
      border-color: #85b7d9;
    }

    @media (max-width: 768px) {
      min-height: 80px;
      padding: 8px 4px;
    }

    @media (max-width: 480px) {
      min-height: 70px;
    }
  }

  > label {
    margin-bottom: 5px;
    font-size: 14px;

    @media (max-width: 768px) {
      font-size: 13px;
    }

    @media (max-width: 480px) {
      font-size: 12px;
    }
  }
`;
